<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
// import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Report Criteria",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Report Criteria",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Criteria",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "subject.name",
          label: "Subject",
          sortable: true,
        },
        {
          key: "criteria",
          label: "Marking Criteria",
          sortable: true,
        },
        {
          key: "subject.sub_class.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        criteria: "",
        subject: "",
      },
      deletedata: {
        criteria: "",
        id: "",
      },
      editdata: {
        criteria: "",
        subject: "",
        id: "",
      },
      pageErrors: {
        criteriaError: "",
        subjectError: "",
      },
      modal: "",
    };
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        this.closeModal(this.modal);
      }
    },
  },
  computed: {
    ...mapGetters("coursework", ["AllCriteria", "SaveStatus"]),
    ...mapGetters("classes", ["NurSubjects"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllCriteria.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllCriteria.length;
  },
  methods: {
    ...mapActions({
      FetchSubjects: "classes/fetchNurSubjects",
      FetchCriteria: "coursework/fetchCriteria",
      AddCriteria: "coursework/addCriteria",
      EddCriteria: "coursework/eddCriteria",
      DeleteCriteria: "coursework/deleteCriteria",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllCriteria.length;
      this.currentPage = 1;
    },

    resetError() {
      this.pageErrors = {
        criteriaError: "",
        subjectError: "",
      };
    },

    resetAddModal() {
      (this.data = {
        criteria: "",
        subject: "",
      }),
        this.resetError();
    },
    resetEditModal() {
      this.editdata.criteria = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.criteria = "";
      this.deletedata.id = "";
    },
    addCriteria(modal) {
      this.modal = modal;
      this.AddCriteria(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata = {
        criteria: values.item.criteria,
        subject: values.item.subject.id,
        id: values.item.id,
      };
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.criteria = values.item.criteria;
    },
    deleteCriteria(modal) {
      this.modal = modal;
      this.DeleteCriteria(this.deletedata);
      this.closeModal(modal);
    },
    eddCriteria(modal) {
      this.modal = modal;
      this.EddCriteria(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSubjects({ level: 3 });
    this.FetchCriteria();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_stream')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Criteria
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-creteria-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_stream')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllCriteria"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(created_at)="data">
                  {{ data.item.created_at.split("T")[0] }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-criteria-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_stream')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-stream-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_stream')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-creteria-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_stream')
          )
        "
      >
        <template #modal-title> Add Criteria </template>
        <form @submit.prevent="addCriteria('add-creteria-modal')">
          <div class="form-group mb-3">
            <label>Criteria Name</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Criteria Description/Name"
                class="form-control"
                required
                v-model="data.criteria"
              />
            </div>
            <div class="text-danger" v-if="pageErrors.criteriaError">
              <em>{{ pageErrors.criteriaError }}</em>
            </div>
          </div>
          <div class="form-group mb-3">
            <label>Subject</label>
            <div class="input-group">
              <select required v-model="data.subject" class="form-control">
                <option v-if="SaveStatus" selected value="" disabled>
                  Fetching Subject...
                </option>
                <option v-else selected value="" disabled
                  >Select Subject</option
                >
                <option
                  v-for="(subject, index) in NurSubjects"
                  :key="index"
                  :value="subject.id"
                >
                  {{ subject.name }}
                </option>
              </select>
            </div>
            <div class="text-danger" v-if="pageErrors.subjectError">
              <em>{{ pageErrors.subjectError }}</em>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              data-dismiss="modal"
              @click="closeModal('add-creteria-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button type="submit" class="btn btn-sm btn-outline-primary">
              <i class="fa fa-check"></i>
              Submit
              <b-spinner
                v-if="SaveStatus"
                variant="light"
                small
                label="Spinning"
              ></b-spinner>
            </button>
          </div>
        </form>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-criteria-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_stream')
          )
        "
      >
        <template #modal-title> Edit Criteria {{ editdata.name }}</template>
        <form @submit.prevent="eddCriteria('edit-criteria-modal')">
          <div class="form-group mb-3">
            <label>Criteria Name</label>
            <div class="input-group">
              <input
                required
                type="text"
                placeholder="Criteria Description/Name"
                class="form-control"
                v-model="editdata.criteria"
              />
            </div>
            <div class="text-danger" v-if="pageErrors.criteriaError">
              <em>{{ pageErrors.criteriaError }}</em>
            </div>
          </div>
          <div class="form-group mb-3">
            <label>Subject</label>
            <div class="input-group">
              <select required v-model="editdata.subject" class="form-control">
                <option v-if="SaveStatus" selected value="" disabled>
                  Fetching subjects...
                </option>
                <option v-else selected value="" disabled
                  >Select Subject</option
                >
                <option
                  v-for="(subject, index) in NurSubjects"
                  :key="index"
                  :value="subject.id"
                >
                  {{ subject.name }}
                </option>
              </select>
            </div>
            <div class="text-danger" v-if="pageErrors.subjectError">
              <em>{{ pageErrors.subjectError }}</em>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              data-dismiss="modal"
              @click="closeModal('edit-criteria-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button type="submit" class="btn btn-sm btn-outline-primary">
              <i class="fa fa-check"></i>
              Save Changes</button
            ><b-spinner
              v-if="SaveStatus"
              variant="primary"
              small
              label="Saving"
            ></b-spinner>
          </div>
        </form>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete stream starts -->
      <b-modal
        id="delete-stream-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_stream')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Delete Criteria {{ deletedata.criteria }}
          </h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6>
              Do you want to delete Criteria
              <strong>({{ deletedata.criteria }})</strong>? <br /><br />
              Click <strong>Proceed</strong>
              Button to delete.
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-stream-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteCriteria('delete-stream-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
